import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import afterLoginApiAxios from "./../../Util/API Calls/afterLogin";
import swal from "sweetalert";
import "./styles.css";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

export default function Group() {
  const [showCreateGroupModal, setCreateGroupShowModal] = useState(false);
  const [showEditGroupModal, setEditGroupShowModal] = useState(false);
  const newNumber = false;
  const notFound = "";
  const [count, setCount] = useState(0);
  const [searchedPatient, setSearchedPatient] = useState("");
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [patients, setPatients] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [createGroup, setCreateGroup] = useState(false);
  const [addPeople, setAddPeople] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groupStatus, setGroupStatus] = useState("");
  const [fullNameList, setFullNameList] = useState([]);
  const [Group_list, setGroup_list] = useState([]);
  const [selectedEditPatientList, setSelectedEditPatientList] = useState({
    patient_info: [],
  });
  const [changed, setChanged] = useState(false);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const updateGroup = () => {
    setEditGroupShowModal(false);
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = userId;
    } catch (error) {}

    let patientIds = [];
    selectedEditPatientList.patient_info.map((ele) => {
      patientIds.push(ele.patient_id);
    });

    afterLoginApiAxios({
      method: "post",
      url: "/doctor/update-group",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        group_id: selectedEditPatientList.group_id,
        doctor_id: doctor_id,
        group_name:
          groupName == "" ? selectedEditPatientList.group_name : groupName,
        patient_list: patientIds,
        status: "1",
      },
    }).then((response) => {
      setGroupName("");
      disableGroup1(groupStatus);
    });
  };

  const DeleteGroup = () => {
    setChanged(false);
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = userId;
    } catch (error) {}

    let patientIds = [];
    selectedEditPatientList.patient_info.map((ele) => {
      patientIds.push(ele.patient_id);
    });

    swal({
      text: "Are you sure you want to permanently delete this group?",
      icon: "warning",
      buttons: ["No", "Yes, Delete"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        afterLoginApiAxios({
          method: "post",
          url: "/doctor/update-group",
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
          data: {
            group_id: selectedEditPatientList.group_id,
            doctor_id: doctor_id,
            group_name: selectedEditPatientList.group_name,
            patient_list: patientIds,
            status: "2",
          },
        }).then((response) => {
          setChanged(true);
          setEditGroupShowModal(false);
        });
      } else {
        setEditGroupShowModal(false);
      }
    });
  };

  const disableGroup1 = (status) => {
    let patientIds = [];
    selectedEditPatientList.patient_info.map((ele) => {
      patientIds.push(ele.patient_id);
    });
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/update-group",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: window.localStorage.getItem("id_token"),
      },
      data: {
        group_id: selectedEditPatientList.group_id,
        doctor_id: userId,
        group_name: selectedEditPatientList.group_name,
        patient_list: patientIds,
        status: selectedEditPatientList.status == "1" ? "4" : "3",
      },
    }).then((response) => {
      listGroups();
    });
  };

  const disableGroup = (status) => {
    let patientsList1 = selectedEditPatientList;

    if (status == "1") {
      patientsList1.status = "3";
      setGroupStatus("3");
      setSelectedEditPatientList(patientsList1);
    } else if (status == "3") {
      patientsList1.status = "1";
      setGroupStatus("1");
      setSelectedEditPatientList(patientsList1);
    }
  };

  const SelectedPatient = ({ id, initials, name, removeSelectedPatient }) => {
    return (
      <div className="selected-contact">
        <span data-letters={initials}></span>
        <i
          className="fa fa-close selected-close-icon"
          onClick={() => removeSelectedPatient(id)}
        ></i>
        <div className="selected-names">{name.split(" ")[0]}</div>
      </div>
    );
  };

  const handleCheckAllPatients = (event) => {
    let patientsAvailable = [...patients];
    let patientsSelected = [...selectedPatients];
    setCheckedAll(event.target.checked);
    patientsAvailable.forEach((p) => {
      p.selected = event.target.checked;
      if (event.target.checked) {
        if (!patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected.push(p);
        }
      } else {
        if (patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected = patientsSelected.filter((ps) => ps.id !== p.id);
        }
      }
    });
    setSelectedPatients(patientsSelected);
    setPatients(patientsAvailable);
  };

  const handleCheckPatientContact = (event) => {
    let patientsAvailable = [...patients];
    let patientsSelected = [...selectedPatients];
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === event.target.value) {
        patientsAvailable[i].selected = event.target.checked;
        if (event.target.checked) {
          if (
            !patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected.push(patientsAvailable[i]);
          }
        } else {
          if (
            patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected = patientsSelected.filter(
              (ps) => ps.id !== patientsAvailable[i].id
            );
          }
        }
      }
    }
    if (patientsSelected.length < patients.length && checkedAll === true) {
      setCheckedAll(false);
    }
    if (patientsSelected.length === patients.length && checkedAll === false) {
      setCheckedAll(true);
    }
    setSelectedPatients(patientsSelected);
    setPatients(patientsAvailable);
  };

  const createGroupModalStatus = () => {
    setCreateGroup(true);
  };
  const AddPeopleStatus = () => {
    let filterpatient = patients.filter((patient) => {
      for (let key in selectedEditPatientList.patient_info) {
        if (
          patient.id == selectedEditPatientList.patient_info[key].patient_id
        ) {
          return false;
        }
      }
      return true;
    });

    setPatients(filterpatient);
    setAddPeople(true);
  };

  const removePeopleStatus = (x) => {
    let finalPatientList;
    let finalSelectedPatientList = selectedEditPatientList.patient_info.filter(
      (ele) => {
        return ele.patient_id != x.patient_id;
      }
    );
    finalPatientList = {
      patient_info: finalSelectedPatientList,
      group_id: selectedEditPatientList.group_id,
      group_name: selectedEditPatientList.group_name,
      status: selectedEditPatientList.status,
    };
    setSelectedEditPatientList(finalPatientList);
  };

  const DisableAddPeopleStatus = () => {
    setAddPeople(false);
    let updateSelectedPatientList = selectedEditPatientList;

    selectedPatients.forEach((ele) => {
      let obj = {
        full_name: ele.name,
        patient_id: ele.id,
        phone_no: ele.phone,
      };

      updateSelectedPatientList.patient_info.push(obj);
    });

    setSelectedEditPatientList(updateSelectedPatientList);
  };

  const PatientContact = ({
    id,
    name,
    initials,
    phone,
    selected,
    handleCheckPatientContact,
  }) => {
    return (
      <div className="checkbox-container my-2">
        <input
          type="checkbox"
          id={id}
          checked={selected}
          value={id}
          key={id}
          onChange={handleCheckPatientContact}
        />
        <label
          htmlFor={id}
          className="ml-2 mr-2 contact-label"
          data-letters={initials}
        >
          <div className="single-contact">
            {name}
            <small className="text-muted">{phone}</small>
          </div>
        </label>
      </div>
    );
  };

  const removeSelectedPatient = (index) => {
    let patientsSelected = [...selectedPatients];
    let patientsAvailable = [...patients];
    patientsSelected = patientsSelected.filter((ps) => ps.id !== index);
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === index) {
        patientsAvailable[i].selected = false;
      }
    }
    if (patientsSelected.length < patients.length && checkedAll === true) {
      setCheckedAll(false);
    }
    setSelectedPatients(patientsSelected);
    setPatients(patientsAvailable);
  };

  const handleCreateGroupCloseModal = () => {
    setCreateGroupShowModal(false);
    setCreateGroup(false);
    setCheckedAll(false);
    setPatients(
      patients.map((item) => Object.assign(item, { selected: false }))
    );
  };
  const handleCreateGroupModal = (event) => {
    if (event.target == event.currentTarget) {
      event.stopPropagation();
    }
    setCreateGroupShowModal(true);
  };

  const handleEditGroupCloseModal = () => {
    setEditGroupShowModal(false);
    setCreateGroup(false);
    setAddPeople(false);
  };

  const EditGroup = (index) => {
    setGroupStatus(Group_list[index].status);
    setSelectedEditPatientList(Group_list[index]);
  };

  const handleEditGroupModal = (event) => {
    if (event.target == event.currentTarget) {
      event.stopPropagation();
    }
    setEditGroupShowModal(true);
  };

  const listGroups = () => {
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = userId;
    } catch (error) {}

    afterLoginApiAxios({
      method: "post",
      url: "/doctor/list-groups/",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        doctor_id: doctor_id,
      },
    }).then((response) => {
      if (response.data.statusCode == 510) {
        setGroup_list([]);
        setFullNameList([]);
      } else {
        setCount(count + 1);
        let Group_list = response.data.group_list.map((x) => {
          let fullNameList = [];
          x.patient_info.map((y) => {
            fullNameList.push(y.full_name);
          });
          return {
            group_id: x.group_id,
            Group_name: x.group_name,
            patient_list: fullNameList,
            status: x.status,
          };
        });

        setGroup_list(response.data.group_list);
        setFullNameList(Group_list);
      }
    });
  };

  useEffect(() => {
    listGroups();
  }, []);

  useEffect(() => {
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = userId;
    } catch (error) {}
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/get-care-group/",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        doctor_id: doctor_id,
        appointment_date: "",
        "authorizer-principal-id": {
          user_type: "1",
        },
      },
    }).then(function (response) {
      let patientsResp = [];
      let apiResp = response.data.all_patients;
      for (let i = 0; i < apiResp.length; i++) {
        let tempPatient = {};
        tempPatient["id"] = apiResp[i]["patient_id"];
        tempPatient["name"] = apiResp[i]["patient_name"];
        tempPatient["phone"] = apiResp[i]["patient_number"];
        tempPatient["selected"] = false;
        if (apiResp[i]["patient_name"].split(" ").length > 1) {
          tempPatient["initials"] =
            apiResp[i]["patient_name"].split(" ")[0].charAt(0) +
            apiResp[i]["patient_name"].split(" ")[1].charAt(0);
        } else {
          tempPatient["initials"] = apiResp[i]["patient_name"]
            .split(" ")[0]
            .charAt(0);
        }
        patientsResp.push(tempPatient);
      }
      setPatients(patientsResp);
    });
  }, [window.localStorage]);

  useEffect(() => {
    setFilteredPatients(
      patients.filter((patient) => {
        return (
          patient.name.toLowerCase().includes(searchedPatient.toLowerCase()) ||
          patient.phone.includes(searchedPatient)
        );
      })
    );
  }, [searchedPatient, patients]);

  useEffect(() => {
    if (changed) {
      listGroups();
    }
  }, [changed]);

  const createNewGroup = () => {
    setChanged(false);
    let token;
    let doctor_id;
    let patient_ids = selectedPatients.map((x) => {
      return x.id;
    });

    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = userId;
    } catch (error) {}
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/create-group/",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        doctor_id: doctor_id,
        group_name: groupName,
        patient_list: patient_ids,
      },
    })
      .then((response) => {
        if (response.data.statusCode == 511) {
          swal({
            type: "danger",
            text: "Group Already exists",
          });
          handleCreateGroupCloseModal();
          setGroupName("");
          setGroup_list([]);
          setFullNameList([]);
          setSelectedPatients([]);
          setCheckedAll(false);
        } else {
          swal({
            type: "success",
            text: "Group Created",
          });
          handleCreateGroupCloseModal();
          setPatients(
            patients.map((item) => Object.assign(item, { selected: false }))
          );
          setChanged(true);
          setGroupName("");
          setGroup_list([]);
          setFullNameList([]);
          setSelectedPatients([]);
          setCheckedAll(false);
        }
      })
      .catch(function (error) {
        C2CConsole.log(error);
      });
  };

  return (
    <div className="container">
      <div
        className="d-flex mt-4 align-items-center mb-4"
        onClick={handleCreateGroupModal}
      >
        <div className="plussIcon mr-2 font-weight-light">+</div>
        <b
          style={{
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Create new Group
        </b>
      </div>

      <div className="row">
        <div
          className="col container_scroll"
          style={{ overflowY: "scroll", height: "50vh" }}
        >
          {fullNameList.map((x, index) => {
            return (
              <IndividualCard
                onClick={(event) => {
                  EditGroup(index);
                  handleEditGroupModal(event);
                }}
                data={x}
                key={x.group_id}
              />
            );
          })}
        </div>
      </div>
      <Modal
        show={showCreateGroupModal}
        onHide={handleCreateGroupCloseModal}
        backdrop="static"
        keyboard={false}
        scrollable="true"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex flex-column">
            <b
              style={{
                fontSize: "14px",
              }}
            >
              Create new group
            </b>
            <b
              style={{
                fontSize: "12px",
                color: "#949494",
              }}
            >
              Add people
            </b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="contact-scroll container_scroll patient-container">
          <div>
            {!createGroup ? (
              <div role="tabpanel" className="tab-pane active" id="tab-4">
                <div className="shadow search-box mx-3">
                  <input
                    type="text"
                    className="search-txt"
                    placeholder="Search by Name or Phone Number"
                    onChange={(e) => setSearchedPatient(e.target.value)}
                  />
                  <span className="search-btn">
                    <i className="fa fa-search"></i>
                  </span>
                </div>
                <small
                  className="text-danger ml-3 mt-2"
                  style={{ display: newNumber ? "block" : "none" }}
                >
                  {notFound}
                </small>
                {selectedPatients.length > 0 ? (
                  <div className="m-2 selected_list">
                    <hr />
                    <div className="selected-contacts mt-3">
                      {selectedPatients.map((sp) => (
                        <SelectedPatient
                          key={sp.id}
                          {...sp}
                          removeSelectedPatient={removeSelectedPatient}
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="select-all my-2">
                  <input
                    type="checkbox"
                    id="select-all"
                    checked={checkedAll}
                    onChange={handleCheckAllPatients}
                  />
                  <label htmlFor="select-all" className="m-3">
                    Select All Contacts
                  </label>
                </div>
                <div className="contact-list">
                  {filteredPatients.map((patient) => (
                    <PatientContact
                      key={patient.id}
                      {...patient}
                      handleCheckPatientContact={handleCheckPatientContact}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className="container-fluid">
                <input
                  className="mt-3"
                  style={{ width: "100%" }}
                  placeholder={"Enter group name"}
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                ></input>
                <h6
                  className="mt-3"
                  style={{
                    fontSize: "12px",
                    color: "#949494",
                  }}
                >
                  <b>{selectedPatients.length} People</b>
                </h6>
                {selectedPatients.map((patient) => (
                  <div>
                    <hr />
                    <div className="d-flex justify-content-between mt-2">
                      <span>{patient.name}</span>
                      <a
                        onClick={() => removeSelectedPatient(patient.id)}
                        style={{ color: "#5CCCE7", cursor: "pointer" }}
                      >
                        Remove
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Modal.Body>
        {!createGroup ? (
          <Modal.Footer className="justify-content-start">
            <button
              type="button"
              className="btn border rounded modal-okay"
              onClick={createGroupModalStatus}
            >
              Next
            </button>
          </Modal.Footer>
        ) : (
          <Modal.Footer
            className="justify-content-start col-md-12 modal-footer"
            style={{ background: "#F5F6F7" }}
          >
            <button
              type="button"
              disabled={!groupName}
              className="col-md-6 btn border rounded modal-okay"
              onClick={createNewGroup}
            >
              Create Group
            </button>
            <button
              type="button"
              className="btn border rounded modal-okay"
              style={{ background: "#F5F6F7", color: "#4BBAE0" }}
              onClick={handleCreateGroupCloseModal}
            >
              Cancel
            </button>
          </Modal.Footer>
        )}
      </Modal>

      <Modal
        show={showEditGroupModal}
        onHide={handleEditGroupCloseModal}
        backdrop="static"
        keyboard={false}
        scrollable="true"
        animation={false}
      >
        <Modal.Header closeButton>
          {!addPeople ? (
            <Modal.Title>
              <b
                style={{
                  fontSize: "14px",
                }}
              >
                View and Edit Details
              </b>
            </Modal.Title>
          ) : (
            <Modal.Title className="d-flex flex-column">
              <b
                style={{
                  fontSize: "14px",
                }}
              >
                Edit Group
              </b>
              <b
                style={{
                  fontSize: "12px",
                  color: "#949494",
                }}
              >
                Add people
              </b>
            </Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body
          className="contact-scroll container_scroll"
          style={{ background: "#F5F6F7", width: "350px", overflowX: "hidden" }}
        >
          {!addPeople ? (
            <div className="container-fluid">
              <input
                className="mt-3"
                style={{ width: "100%" }}
                onChange={(e) => setGroupName(e.target.value)}
                defaultValue={selectedEditPatientList.group_name}
              ></input>
              <h6
                className="mt-3"
                style={{
                  fontSize: "12px",
                  color: "#949494",
                }}
              >
                <b>{selectedEditPatientList.patient_info.length} People</b>
              </h6>
              <div
                className="d-flex mt-4 align-items-center"
                onClick={AddPeopleStatus}
              >
                <div className="plussIcon mr-2">+</div>
                <b
                  style={{
                    fontSize: "16px",
                  }}
                >
                  Add People
                </b>
              </div>
              <div>
                {selectedEditPatientList.patient_info.map((x) => (
                  <div className="d-flex justify-content-between mt-2">
                    <span>{x.full_name}</span>
                    <a
                      style={{ color: "#5CCCE7", cursor: "pointer" }}
                      onClick={() => removePeopleStatus(x)}
                    >
                      Remove
                    </a>
                  </div>
                ))}
              </div>
              <div>
                <hr />
              </div>
              <div className="d-flex flex-column mt-4">
                <b
                  style={{
                    fontSize: "14px",
                    color: "red",
                    cursor: "pointer",
                  }}
                  onClick={DeleteGroup}
                >
                  Delete Group
                </b>
                <b
                  style={{
                    fontSize: "12px",
                    color: "#949494",
                  }}
                >
                  Permanently delete this group
                </b>
              </div>
              <div className="mt-4 d-flex justify-content-between">
                <div className="d-flex flex-column">
                  <b
                    style={{
                      fontSize: "14px",
                      color: "black",
                    }}
                  >
                    Disable Group
                  </b>
                  <b
                    style={{
                      fontSize: "12px",
                      color: "#949494",
                    }}
                  >
                    Mute activities on this group
                  </b>
                </div>
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="customSwitchesChecked"
                    checked={groupStatus == 3 ? true : false}
                    onChange={() => {
                      disableGroup(selectedEditPatientList.status);
                    }}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customSwitchesChecked"
                  ></label>
                </div>
              </div>
            </div>
          ) : (
            <div role="tabpanel" className="tab-pane active" id="tab-4">
              <div className="shadow search-box mx-3">
                <input
                  type="text"
                  className="search-txt"
                  placeholder="Search by Name or Phone Number"
                />
                <span className="search-btn">
                  <i className="fa fa-search"></i>
                </span>
              </div>
              <small
                className="text-danger ml-3 mt-2"
                style={{ display: newNumber ? "block" : "none" }}
              >
                {notFound}
              </small>
              {selectedPatients.length > 0 ? (
                <div className="m-2">
                  <hr />
                  <div className="selected-contacts mt-3">
                    {selectedPatients.map((sp) => (
                      <SelectedPatient
                        key={sp.id}
                        {...sp}
                        removeSelectedPatient={removeSelectedPatient}
                      />
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="select-all my-2">
                <input
                  type="checkbox"
                  id="select-all"
                  checked={checkedAll}
                  onChange={handleCheckAllPatients}
                />
                <label htmlFor="select-all" className="m-3">
                  Select All Contacts
                </label>
              </div>
              <div className="contact-list">
                {filteredPatients.map((patient) => (
                  <PatientContact
                    key={patient.id}
                    {...patient}
                    handleCheckPatientContact={handleCheckPatientContact}
                  />
                ))}
              </div>
            </div>
          )}
        </Modal.Body>
        {!addPeople ? (
          <Modal.Footer
            className="justify-content-start col-md-12 modal-footer"
            style={{ background: "#F5F6F7" }}
          >
            <button
              type="button"
              className="col-md-6 btn border rounded modal-okay"
              onClick={updateGroup}
            >
              Save Changes
            </button>
            <button
              type="button"
              className="btn border rounded modal-okay"
              style={{ background: "#F5F6F7", color: "#4BBAE0" }}
              onClick={handleEditGroupCloseModal}
            >
              Cancel
            </button>
          </Modal.Footer>
        ) : (
          <Modal.Footer className="justify-content-start">
            <button
              type="button"
              className="btn border rounded modal-okay pl-2 pr-2"
              onClick={DisableAddPeopleStatus}
            >
              Add People
            </button>
          </Modal.Footer>
        )}
      </Modal>
    </div>
  );
}

const IndividualCard = (x) => {
  return (
    <div>
      {x.data.status == "1" ? (
        <div
          className="card "
          style={{ cursor: "pointer" }}
          onClick={x.onClick}
        >
          <div className="card-body">
            <div className="d-flex align-items-lg-center justify-content-between">
              <div>
                <h6 className="card-title">{x.data.Group_name}</h6>
                <p className="card-text">{x.data.patient_list.join(", ")}</p>
              </div>
              <span className="h3 font-weight-light">{">"}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="card" style={{ cursor: "pointer" }} onClick={x.onClick}>
          <div className="card-body">
            <div className="d-flex align-items-lg-center justify-content-between">
              <div>
                <h6 className="card-title text-muted">{x.data.Group_name}</h6>
                <p className="card-text text-muted">
                  {x.data.patient_list.join(", ")}
                </p>
                <p className="card-text disabled-doctor-group">
                  Group has been disabled.
                </p>
              </div>
              <span className="h3 font-weight-light">{">"}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
